<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <DownloadButton :caller="caller" :id="form.main.id || bizData.bizId" />
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.sa_code }}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <custom-layout :view-config="customViewConfig">
            <div class="weui-form-preview__item" slot="sa_custname">
              <label class="weui-form-preview__label">{{
                customLabel.sa_custname || "客户名称"
              }}</label>
              <em class="weui-form-preview__value">{{
                form.main.sa_custname
              }}</em>
            </div>
            <div class="weui-form-preview__item" slot="sa_contact">
              <label class="weui-form-preview__label">{{
                customLabel.sa_contact || "联系人"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ form.main.sa_contact }} {{ form.main.sa_tel }}
                <call-mobile :mobile="form.main.sa_tel"></call-mobile>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sa_toplace">
              <label class="weui-form-preview__label">{{
                customLabel.sa_toplace || "收货地址"
              }}</label>
              <span
                class="weui-form-preview__value"
                :class="{
                  'weui-form-preview__value-icon': !!form.main.sa_toplace,
                }"
                >{{ form.main.sa_toplace }}
                <router-link
                  v-if="form.main.sa_toplace"
                  class="iconfont icon-map"
                  :to="'/map/baidu?keywords=' + form.main.sa_toplace"
                ></router-link>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sa_payments">
              <label class="weui-form-preview__label">{{
                customLabel.sa_payments || "收款方式"
              }}</label>
              <span class="weui-form-preview__value">
                {{ form.main.sa_payments }}
                <span v-if="form.main.sa_currency">{{
                  form.main.sa_currency
                }}</span>
                <span v-if="form.main.sa_rate && form.main.sa_rate != 1"
                  >/ {{ form.main.sa_rate }}</span
                >
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sa_taxrate">
              <label class="weui-form-preview__label">{{
                customLabel.sa_taxrate || "税率"
              }}</label>
              <span class="weui-form-preview__value">
                {{ form.main.sa_taxrate }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="sa_date">
              <label class="weui-form-preview__label">{{
                customLabel.sa_date || "订单日期"
              }}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd'"
                key="yyyy-MM-dd"
                >{{ form.main.sa_date }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="sa_class">
              <label class="weui-form-preview__label">{{
                customLabel.sa_class || "销售类型"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.sa_class
              }}</span>
            </div>
            <custom-field
              :readOnly="true"
              :label="customLabel.sa_text1 || '自定义字段1'"
              v-model="form.main.sa_text1"
              slot="sa_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sa_text2 || '自定义字段2'"
              v-model="form.main.sa_text2"
              slot="sa_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sa_text3 || '自定义字段3'"
              v-model="form.main.sa_text3"
              slot="sa_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sa_text4 || '自定义字段4'"
              v-model="form.main.sa_text4"
              slot="sa_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sa_text5 || '自定义字段5'"
              v-model="form.main.sa_text5"
              slot="sa_text5"
              hidden="true"
            />
          </custom-layout>
          <div
            class="weui-form-preview__item"
            slot="sa_seller"
            v-if="form.main.sa_seller"
          >
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.sa_seller }}
              <call-mobile :em-id="form.main.sa_sellerid"></call-mobile>
            </span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="sa_dpname"
            v-if="form.main.sa_dpname"
          >
            <label class="weui-form-preview__label">事业部门</label>
            <span class="weui-form-preview__value"
              >{{ form.main.sa_dpname }}
            </span>
          </div>
        </div>
      </div>
      <collapse
        class="form-preview weui-form-preview"
        :title="'明细（' + form.items.length + '条）'"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="sd_prodcode">
              <label class="weui-form-preview__label">{{
                customLabel.sd_prodcode || "产品编号"
              }}</label>
              <span
                class="weui-form-preview__value text-link"
                @click="showProduct(item)"
                >{{ item.productDTO.pr_code }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "产品名称"
              }}</label>
              <span
                class="weui-form-preview__value text-link"
                @click="showProduct(item)"
                >{{ item.productDTO.pr_detail }}</span
              >
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.productDTO && item.productDTO.pr_orispeccode"
              slot="pr_orispeccode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.productDTO && item.productDTO.pr_spec"
              slot="pr_spec"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_spec
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sd_qty">
              <label class="weui-form-preview__label">{{
                customLabel.sd_qty || "数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.sd_qty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div
              class="weui-form-preview__item"
              slot="sd_qty_extra"
              v-if="item.productDTO && item.productDTO.pr_unit_extra"
            >
              <label class="weui-form-preview__label">{{
                customLabel.sd_qty_extra || "辅助数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.sd_qty_extra }}
                {{ item.productDTO.pr_unit_extra }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="sd_netprice">
              <label class="weui-form-preview__label">{{
                customLabel.sd_netprice || "不含税单价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.sd_netprice, "#,##0.####")
              }}</span>
            </div>

            <div class="weui-form-preview__item" slot="sd_price">
              <label class="weui-form-preview__label">{{
                customLabel.sd_price || "含税单价(元)"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
              >
                {{ numberFormat(item.sd_price, "#,##0.####") }}
                <router-link
                  class="iconfont icon-history"
                  :to="{
                    path: '/sale/order_report',
                    query: { hq_keyword: item.sd_prodcode },
                  }"
                ></router-link>
              </span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="sd_price_extra"
              v-if="item.productDTO && item.productDTO.pr_unit_extra"
            >
              <label class="weui-form-preview__label">{{
                customLabel.sd_price_extra || "辅助单价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.sd_price_extra
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sd_nettotal">
              <label class="weui-form-preview__label">{{
                customLabel.sd_nettotal || "不含税金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.sd_nettotal, "#,##0.00")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sd_total">
              <label class="weui-form-preview__label">{{
                customLabel.sd_total || "含税金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.sd_total, "#,##0.00")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sd_delivery">
              <label class="weui-form-preview__label">{{
                customLabel.sd_delivery || "交货日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                dateFormat(item.sd_delivery, "yyyy-MM-dd")
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="sd_yqty"
              v-if="!readonly"
            >
              <label class="weui-form-preview__label">{{
                customLabel.sd_yqty || "已转数"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.sd_yqty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.productDTO.pr_saleprice"
              slot="pr_saleprice"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_saleprice || "最近售价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.productDTO.pr_saleprice, "#,##0.####")
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.sd_remark"
              slot="sd_remark"
            >
              <label class="weui-form-preview__label">{{
                customLabel.sd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.sd_remark }}</span>
            </div>

            <div class="weui-form-preview__item" v-if="!editable && !readonly">
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
              >
                <i class="iconfont icon-change" @click="onchange(item)">变更</i>
              </span>
            </div>
            <custom-field
              :readOnly="true"
              :label="customLabel.sd_text1 || '自定义字段1'"
              v-model="item.sd_text1"
              slot="sd_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sd_text2 || '自定义字段2'"
              v-model="item.sd_text2"
              slot="sd_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sd_text3 || '自定义字段3'"
              v-model="item.sd_text3"
              slot="sd_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sd_text4 || '自定义字段4'"
              v-model="item.sd_text4"
              slot="sd_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.sd_text5 || '自定义字段5'"
              v-model="item.sd_text5"
              slot="sd_text5"
              hidden="true"
            />
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.sa_nettotal
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.sa_taxtotal
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.sa_total
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.sa_rate && form.main.sa_rate != 1">
            <label class="weui-form-preview__label">本币价税合计</label>
            <span>{{ CURRENCY_SYMBOLS[currency] }}</span>
            <span  v-format="'#,##0.00'"
              >{{ form.main.sa_total_std }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.sa_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_remark
            }}</span>
          </div>
        </div>
      </div>
      <div>
      </div>

      <file-list v-model="form.main.sa_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/sale/order_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnout"
        >出货</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnpurc"
        >采购</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnApplication"
        >请购</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";
import Share from "@/components/button/Share.vue";
import Collapse from "@/components/Collapse.vue";
import CustomField from "@/components/field/CustomField.vue";
import FileList from "@/components/FileList.vue";
import DownloadButton from "@/components/button/Download.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CallMobile,
    Share,
    Collapse,
    CustomField,
    FileList,
    DownloadButton,
  },
  data() {
    return {
      baseUrl: "/api/sale/sale",
      codeField: "sa_code",
      statusField: "sa_statuscode",
      caller: "Sale",
      xtype: "sale-sale-formpanel",
      currency: "",
      CURRENCY_SYMBOLS: {
        'RMB': '￥',
        'CNY': '￥',
        'EUR': '€',
        'HKD': 'HK$',
        'JPY': 'J￥',
        'USD': '$',
        'NTD': 'NT$',
    },
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.sa_code,
        bizType: "Sale",
        bizId: main.id,
        viewType: "sale-sale-formpanel",
        title: "销售订单" + main.sa_code,
      };
    },
  },
  created() {
    this.loadDefault()
  },
  methods: {
    onchange(item) {
      if (item.sd_yqty >= item.sd_qty) {
        this.$weui.topTips("明细行已全部转出货，不能分拆", 3000);
      } else {
        this.$router.push({
          name: "SaleOrderChangeEdit",
          params: {
            itemData: item,
          },
        });
      }
    },
    /**
     * 转出货
     */
    turnout() {
      var me = this,
        id = me.form.main.id;
      me.$weui.confirm("确定转出货单？", function () {
        me.$loading({
          url: "/api/sale/sale/turnSaleOut/" + id,
          method: "POST",
        })
          .then(function (res) {
            let data = res.data;
            if (res.success && data) {
              let id = data.created ? data.created.id : data.history[0].bizId;
              me.$weui.toast("转出货成功", 2000);
              me.$router.push("/sale/out/" + id);
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function () {
            me.$weui.topTips("转出货失败", 3000);
          });
      });
    },
    /**
     * 转采购
     */
    turnpurc() {
      var me = this,
        id = me.form.main.id;
      me.$weui.confirm("确定下达采购单？", function () {
        me.$loading({
          url: "/api/sale/sale/saleTurnPurchase/" + id,
          method: "POST",
        })
          .then(function (res) {
            if (res.success) {
              me.$weui.toast("转采购成功", 2000);
              me.$router.push("/purchase/order/" + res.data.id);
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function () {
            me.$weui.topTips("转采购失败", 3000);
          });
      });
    },
    /**
     * 转请购单
     */
    turnApplication() {
      var me = this,
        id = me.form.main.id;
      me.$weui.confirm("确定下达请购单？", function () {
        me.$loading({
          url: "/api/sale/sale/saleTurnApplication/" + id,
          method: "POST",
        })
          .then(function (res) {
            if (res.success) {
              me.$weui.toast("转请购成功", 2000);
              me.$router.push("/purchase/apply/" + res.data.id);
            } else {
              me.$weui.topTips(res.message, 3000);
            }
          })
          .catch(function () {
            me.$weui.topTips("转请购失败", 3000);
          });
      });
    },
    /**
     * 跳转产品资料
     *
     * @param {*} item
     */
    showProduct(item) {
      this.$router.push("/document/product/" + item.sd_prodid);
    },
    loadDefault() {
      var me = this;
      me.$loading({
        url: "/api/document/currency/getStandard",
      }).then(function (res) {
        if (res.success) {
          me.currency = res.data.cr_name;
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
  },
};
</script>